<template>
  <va-card>
    <div class="row">
      <div class="flex md12 xs12">
        <va-card class="chart-widget card" :title="$t('Rules')">
          <form @submit.prevent="onsubmit">
            <va-input
              v-model="payload.email_pattern"
              type="text"
              :label="$t('email pattern')"
            />

            <va-input
              v-model="payload.ip_address"
              type="text"
              :label="$t('ip_address')"
            />

            <va-input
              v-model="payload.order_item_product_service"
              type="text"
              :label="$t('product service')"
            />

            <va-input
              v-model="payload.order_item_target_pattern"
              type="text"
              :label="$t('target pattern')"
            />

            <div class="d-flex justify--center items-center mt-3 btns-wrapper">
              <va-button type="submit" class="my-0 mr-auto">{{ $t('Submit') }}</va-button>
              <va-button @click.prevent="deleteBanRule">Delete</va-button>
            </div>
          </form>
        </va-card>
      </div>
    </div>
    <div class="row">
      <div class="flex md12 xs12">
        <va-card class="chart-widget card" :title="$t('Related orders')">
          <va-data-table
            :fields="fields"
            :data="orders"
            :loading="loading"
            api-mode
            :totalPages="totalPages"
            :per-page="parseInt(filter.limit)"
            :rowClass="() => 'ordersTable'"
            @page-selected="readPage"
            @row-clicked="viewDetails"
          >
            <template slot="id" slot-scope="props">
              <router-link :to="{ name: 'select-order', params: { id: props.rowData.id }}"
                :style="{color: '#34495e'}">
                {{ props.rowData.id }}
              </router-link>
            </template>

            <template slot="source_site" slot-scope="props">
              <span
                :style="{ background: props.rowData.source_site.color }"
                class="source-site"
              >
                {{ props.rowData.source_site.domain_name }}
              </span>
            </template>

            <template slot="create_timestamp" slot-scope="props">
              {{ parseDate(props.rowData.create_timestamp) }}
            </template>
          </va-data-table>
        </va-card>
      </div>
    </div>
  </va-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Ban-rules-detail',
  data () {
    return {
      payload: {
        email_pattern: '',
        ip_address: '',
        order_item_product_service: '',
        order_item_target_pattern: '',
      },
      orders: [],
      totalCount: 0,
      filter: {
        limit: '20',
        offset: '',
        ban_reason__id: this.$route.params.id,
      },
      perPageOptions: ['20', '50', '100', '200'],
      loading: true,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:id',
          title: this.$t('orders.id'),
        },
        {
          name: 'order_id',
          title: this.$t('orders.order_id'),
        },
        {
          name: 'email',
          title: this.$t('orders.email'),
        },
        {
          name: 'first_name',
          title: this.$t('orders.first_name'),
        },
        {
          name: 'last_name',
          title: this.$t('orders.last_name'),
        },
        {
          name: '__slot:source_site',
          title: this.$t('orders.source_site'),
        },
        {
          name: 'requested_payment_method',
          title: this.$t('orders.payment_method.name'),
        },
        {
          name: 'amount',
          title: this.$t('orders.amount'),
        },
        {
          name: '__slot:create_timestamp',
          title: this.$t('orders.create_timestamp'),
        },
      ]
    },
    totalPages () {
      return Math.ceil(this.totalCount / this.filter.limit)
    },
    getFilterQueryString () {
      let Query = '?'
      for (const getKey in this.filter) {
        if (Object.hasOwnProperty.call(this.filter, getKey)) {
          const getValue = this.filter[getKey]

          Query += getValue ? `${getKey}=${getValue}&` : ''
        }
      }
      return Query.slice(0, -1)
    },
  },
  methods: {
    onsubmit () {
      for (const [key, val] of Object.entries(this.payload)) {
        if (val != null && !val.replace(/\s/g, '').length) {
          this.payload[key] = null
        }
      }
      axios
        .put(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/ban-rules/${this.$route.params.id}/`, this.payload)
        .catch(
          (err) => {
            const errors = []
            for (const val of Object.values(err.response.data)) {
              errors.push(val[0])
            }
            alert(errors.join('\n'))
          },
        )
    },
    readPage (page = 1) {
      this.filter.offset = (page - 1) * this.filter.limit
      this.updateTable(this.getFilterQueryString)
    },
    updateTable () {
      axios.get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/orders/${this.getFilterQueryString}`)
        .then(
          ({ data }) => {
            this.orders = data.results
            this.totalCount = data.count
          },
        )
    },
    viewDetails (selectedObj) {
      this.$router.push({
        name: 'select-order',
        params: { id: selectedObj.id },
      })
    },
    deleteBanRule () {
      axios
        .delete(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/ban-rules/${this.$route.params.id}/`)
        .then(
          () => {
            this.$router.push({
              name: 'ban-rules-list',
            })
          },
        )
    },
  },
  created () {
    axios
      .get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/ban-rules/${this.$route.params.id}/`)
      .then(({ data }) => {
        this.payload.email_pattern = data.email_pattern
        this.payload.ip_address = data.ip_address
        this.payload.order_item_product_service = data.order_item_product_service
        this.payload.order_item_target_pattern = data.order_item_target_pattern
      })

    axios
      .get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/orders/${this.getFilterQueryString}`)
      .then(
        ({ data }) => {
          this.orders = data.results
          this.totalCount = data.count
          this.loading = false
        },
      )
  },
}
</script>

<style>
  .ordersTable {
    cursor: pointer;
  }

  .btns-wrapper button:last-child {
    background-color: #b92828 !important;
  }
</style>
